/**
 * Case folding for item/serial/name search. Uses English ("en") rules for Latin
 * letters so e.g. "USB" and "usb" match; Hebrew and digits are unchanged.
 */
export function normalizeItemSearchText(value) {
  if (value == null) return "";
  return String(value).toLocaleLowerCase("en");
}
